import { StyleSheet } from 'react-native';
import { colors } from 'src/constants/theme';
import { isWeb } from 'src/utils';
import { responsiveWidth } from 'src/utils/responsive';

const styles = StyleSheet.create({
  card: {
    width: isWeb() ? 'calc(100% - 40px)' : responsiveWidth(100) - 40,
    padding: isWeb() ? 10 : 15,
  },
  cardHeader: {
    backgroundColor: 'transparent',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  divider: { marginVertical: 5 },
  status: { marginLeft: 10 },
  username: { marginLeft: 10 },
  indicator: {
    marginLeft: 5,
    backgroundColor: colors.blue2,
    width: 8,
    height: 8,
    borderRadius: 1000,
  },
});

export default styles;
